import React from 'react';
import SvgIcon from '../../SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function DrinkIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <title>Drink</title>
      <path d="M12.0937 3.66666C14.7447 3.66666 16.9032 4.59754 17.032 5.7662L17.8333 7.05579L17.8175 16.953L17.0445 18.1243C17.0445 19.345 14.8279 20.3333 12.0937 20.3333C9.35892 20.3333 7.14295 19.345 7.14295 18.1243L6.18184 17.0475L6.16666 7.38545L7.15483 5.7662C7.28355 4.59754 9.44209 3.66666 12.0937 3.66666ZM12 4.49999C9.5732 4.49999 7.93806 5.44166 7.83823 6.10379L7.83332 6.1671L7.83847 6.2322C7.93425 6.84879 9.36026 7.70603 11.5147 7.82085C11.6737 7.82672 11.8294 7.83332 12 7.83332C12.1705 7.83332 12.3262 7.82672 12.4852 7.82085C14.6397 7.70603 16.0657 6.84879 16.1614 6.2322L16.1667 6.16695L16.1618 6.10379C16.062 5.44166 14.4268 4.49999 12 4.49999ZM12.0699 5.62304L12.1469 5.63016C12.3474 5.66766 12.5059 5.84914 12.5387 6.07877L12.5448 6.1671L12.5386 6.25528C12.5018 6.51361 12.3058 6.71101 12.0698 6.71101H10.3404L10.2633 6.70388C10.0628 6.66639 9.90432 6.48491 9.87158 6.25528L9.86542 6.16695L9.87164 6.07877C9.90848 5.82043 10.1045 5.62304 10.3404 5.62304H12.0699Z" />
    </SvgIcon>
  );
}

export default DrinkIcon;
